/**
* Arrow Links Banner JS
* -----------------------------------------------------------------------------
*
* All the JS for the Arrow Links Banner component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'arrow-links-banner',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );

      $( '.arrow-links-banner' ).each( function( key, val ) {
        const image1 = $( this ).find( '.image-1' )[0];
        const image2 = $( this ).find( '.image-2' )[0];
        const image3 = $( this ).find( '.image-3' )[0];
        const height = $( this ).outerHeight();

        if ( !window.matchMedia( '(prefers-reduced-motion)' ).matches ) {
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: 'top bottom',
              end: 'bottom top',
              scrub: 0,
            },
          } );
          tl.to( image1, {y: '25%', ease: 'linear'}, 0 );
          tl.to( image3, {y: '-25%', ease: 'linear'}, 0 );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'arrow-links-banner', COMPONENT );
} )( app );
